module.exports = __webpack_public_path__ + "fm.1d9aff75.svg";